import React, { Component } from "react";
import { List, Tag, Row, Col, Modal } from "antd";
import IconSelect from "components/icons/IconSelect";
import SubjectItemPopOver from "./pop-overs/SubjectItemPopOver";
import DefineAssumedPopOver from "./pop-overs/DefineAssumedPopOver";
import DefinePrereqPopOver from "./pop-overs/DefinePrereqPopOver";
import "styles/SubjectItem.scss";
import IconWarning from "assets/Icon-Warning.svg";
export default class SubjectItem extends Component {
  state = {
    showModal: false,
    inspectedCourse: null,
    // 2 definitions
    showAssumedModal: false,
    showPrereqModal: false,
  };

  // OPTIONAL PREREQUE POPOVERS
  handleCancel = () => this.setState({ showModal: false });
  openPopOver = (pre) => {
    this.setState({ showModal: true });
    this.setState({ inspectedCourse: pre });
  };

  // Assumed popovers
  openAssumed = () => this.setState({ showAssumedModal: true });
  closeAssumed = () => this.setState({ showAssumedModal: false });

  // Prereq popovers
  openPrereq = () => this.setState({ showPrereqModal: true });
  closePrereq = () => this.setState({ showPrereqModal: false });

  makePrereqs = () => {
    const { prerequisite_of, showSelect } = this.props;
    let prereqP = {};
    let prereqS = {};
    let prereqA = {};
    // objects with title, institution and code
    if (prerequisite_of) {
      prerequisite_of.forEach((p) => {
        if (p.type === "P") {
          prereqP[p.course.course_code] = {
            code: p.course.course_code,
            title: p.course.title,
            institution: p.course.institution,
          };
        } else if (p.type === "S") {
          prereqS[p.course.course_code] = {
            code: p.course.course_code,
            title: p.course.title,
            institution: p.course.institution,
          };
        } else if (p.type === "A") {
          prereqA[p.course.course_code] = {
            code: p.course.course_code,
            title: p.course.title,
            institution: p.course.institution,
          };
        }
      });
    }
    return (
      <div>{this.renderPrereqs(showSelect, prereqP, prereqA, prereqS)}</div>
    );
  };

  renderPrereqs = (showSelect, prereqP, prereqA, prereqS) => (
    <div className={showSelect ? "prereq-container" : ""}>
      {this.renderPrereqS(prereqS)}
      {this.renderPrereqA(prereqA)}
      {this.renderPrereqP(prereqP)}
    </div>
  );

  renderPrereqP = (prereqP) =>
    Object.keys(prereqP).length > 0 && (
      <Row>
        <Col sm={24} md={6} onClick={this.openPrereq}>
          <Tag className="subject-item-tag-prereq">Prereq</Tag>
        </Col>
        <Col sm={24} md={18}>
          {Object.keys(prereqP).map((key) => (
            <p key={key} className="tag-prereq-uni">
              {`${prereqP[key].title}, ${prereqP[key].institution}`}
            </p>
          ))}
        </Col>
      </Row>
    );
  renderPrereqA = (prereqA) =>
    Object.keys(prereqA).length > 0 && (
      <Row>
        <Col sm={24} md={6} onClick={this.openAssumed}>
          <Tag className="subject-item-tag-assumed">Assumed</Tag>
        </Col>
        <Col sm={24} md={18}>
          {Object.keys(prereqA).map((key) => (
            <p key={key} className="tag-prereq-uni">
              {`${prereqA[key].title}, ${prereqA[key].institution}`}
            </p>
          ))}
        </Col>
      </Row>
    );
  renderPrereqS = (prereqS) =>
    Object.keys(prereqS).length > 0 &&
    Object.keys(prereqS).map((key) => (
      <Row
        key={key}
        className="subject-item-tag-button"
        onClick={() => this.openPopOver(key)}
      >
        <Col sm={24} md={6}>
          <Tag className="subject-item-tag-subject">Optional</Tag>
        </Col>
        <Col sm={24} md={18}>
          <p className="tag-prereq-uni">{`${prereqS[key].title}, ${prereqS[key].institution}`}</p>
        </Col>
      </Row>
    ));

  render() {
    const {
      subject_num,
      name,
      category,
      units,
      subjectItemSelected,
      subjectError,
      showSelect,
    } = this.props;
    let { handleToggleSubject } = this.props;

    if (!handleToggleSubject) handleToggleSubject = () => false;
    // if handleToggleSubject is null, we are at Atar Eligibility

    return (
      <List.Item className="flex-space-between subject-item">
        <Modal
          open={this.state.showModal}
          onCancel={this.handleCancel}
          footer={null}
        >
          <SubjectItemPopOver id={this.state.inspectedCourse} />
        </Modal>
        {/* Assumed */}
        <Modal
          open={this.state.showAssumedModal}
          onCancel={this.closeAssumed}
          footer={null}
        >
          <DefineAssumedPopOver />
        </Modal>

        <Modal
          open={this.state.showPrereqModal}
          onCancel={this.closePrereq}
          footer={null}
        >
          <DefinePrereqPopOver />
        </Modal>

        <div className="width-100">
          <div
            className="subject-list-item-header"
            onClick={() => handleToggleSubject(subject_num)}
          >
            <div className="check-and-title">
              {showSelect && <IconSelect selected={subjectItemSelected} />}

              <h2
                className={"subject-title " + (showSelect ? "margin-left" : "")}
              >
                {name}
              </h2>
            </div>
            <div className="tags">
              <div className="tag-units">{units}</div>
            </div>
          </div>
          {this.makePrereqs()}
          {subjectError && (
            <div className="eligibility-subject-error-message">
              <img
                className="margin-right"
                src={IconWarning}
                alt="warning"
                width="16px"
                style={{ display: "inline-block" }}
              />
              {subjectError.message}
            </div>
          )}
        </div>
      </List.Item>
    );
  }
}
